import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import Nav from "../Nav"

export default function CalendlyAttributionReport({ user }) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  const fetchData = (start, end) => {
    setLoading(true)
    setError(null)

    const params = new URLSearchParams()
    if (start) params.append("start_date", start)
    if (end) params.append("end_date", end)

    const url = params.toString() ? `/api/reports/calendly_attribution?${params}` : "/api/reports/calendly_attribution"

    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`)
        }
        return res.json()
      })
      .then((json) => {
        setData(json.data || [])
        setLoading(false)
      })
      .catch((err) => {
        setError(err.message)
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchData("", "")
  }, [])

  const handleApplyFilter = (e) => {
    e.preventDefault()
    fetchData(startDate, endDate)
  }

  const handleClearFilter = () => {
    setStartDate("")
    setEndDate("")
    fetchData("", "")
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Nav user={user} />

      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-center gap-2">
          <Link to="/" className="text-blue-600 hover:text-blue-700">
            Dashboard
          </Link>
          <span className="text-gray-400">/</span>
          <span className="text-gray-600">Calendly Event Attribution</span>
        </div>

        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="px-5 py-6 sm:px-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">Calendly Event Attribution</h2>
            <p className="mt-2 text-gray-600">Invitee counts grouped by UTM source</p>
          </div>

          <div className="px-5 py-6 sm:px-6 border-b border-gray-200 bg-gray-50">
            <form onSubmit={handleApplyFilter} className="space-y-4">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:items-end">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="flex gap-2">
                  <button
                    type="submit"
                    className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium"
                  >
                    Apply Filter
                  </button>
                  <button
                    type="button"
                    onClick={handleClearFilter}
                    className="flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 font-medium"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="overflow-x-auto">
            {loading && (
              <div className="px-6 py-8 text-center text-gray-600">
                Loading...
              </div>
            )}

            {error && (
              <div className="px-6 py-8 text-center text-red-600">
                Error: {error}
              </div>
            )}

            {!loading && !error && data?.length === 0 && (
              <div className="px-6 py-8 text-center text-gray-600">
                No data available
              </div>
            )}

            {!loading && !error && data?.length > 0 && (
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">UTM Source</th>
                    <th className="px-6 py-3 text-right text-sm font-semibold text-gray-900">Invitees</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {data.map((row) => (
                    <tr key={row.utm_source} className="hover:bg-gray-50">
                      <td className="px-6 py-4 text-gray-900">{row.utm_source}</td>
                      <td className="px-6 py-4 text-right text-gray-900 font-medium">{row.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
